module.exports = __webpack_public_path__ + "static/img/new-agv.f39b14b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/new-agv.png
// module id = 4T5W
// module chunks = 28